(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ManageProducts",
                {
                    url: "/ManageProducts",
                    component: "manageProducts",
                    requiredPermissions: [{ AccessObject: "Products", ActionType: "View" }],
                    resolve: {
                        products: [
                            "productApi", function (productApi) {
                                return productApi.getProducts();
                            }
                        ]
                    }
                });
        }
    ]);
    app.component("manageProducts",
        {
            templateUrl: "/App/ConfigureSystem/ManageProducts/template.html",
            controller: manageProductsController,
            bindings: {
                products: "<"
            }
        });


    manageProductsController.$inject = [
        "$mdDialog", "productApi", "_", "$state", "permissionService", "figToaster"
    ];

    function manageProductsController($mdDialog, productApi, _, $state, permissionService, figToaster) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                permissionService: permissionService,
                UI: {
                    SearchText: "",
                    isClosing: false,
                    isSaving: false,
                    Sort: "Carrier.Business.Name",
                    Reverse: false,
                    isUpdatingProducts: false
                },
                carriers: _.uniq(_.map($ctrl.products,
                    function (p) {
                        return p.Carrier.Business.Name;
                    })),
                editProduct: editProduct,
                goBack: goBack,
                close: close
            });


        $ctrl.updateAllProducts = function () {
            $ctrl.UI.isUpdatingProducts = true;
            return productApi.updateAllProducts()
                .then(function (response) {
                    $ctrl.products = response;
                    return figToaster.showSimple('All products updated successfully.', 'top right');
                })
                .catch(function () {
                    return figToaster.showError('An error occured while updating your products. Please try again shortly.', 'top right');
                })
                .finally(function () {
                    return $ctrl.UI.isUpdatingProducts = false;
                });
        };

        function editProduct(product, $event) {
            //return $state.go(".Detail", { arcProductId: product.ArcProductId });

            var productModal = {
                templateUrl: "/App/ConfigureSystem/ManageProducts/ProductDetail/template.html",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false,
                controller: productDetailController,
                controllerAs: "$ctrl",
                bindToController: true,
                resolve: {
                    product: ["productApi", function (productApi) {
                        return productApi.getArcProduct(product.ArcProductId);
                    }]
                }
            };

            $mdDialog.show(productModal).then(function (response) {
                for (var i = 0; i < $ctrl.products.length; i++) {
                    if ($ctrl.products[i].ArcProductId === response.product.ArcProductId) {
                        $ctrl.products[i] = response.product;
                        return; //keep return to workaround duplicate product backend issue. If dupes exist, the wrong dupe may get updated in the UI instead
                    }
                }
            });
        }

        function goBack() {
            return $state.go("^");
        }

        function close() {
            $ctrl.UI.isClosing = true;
            $mdDialog.hide().then(function () { $ctrl.UI.isClosing = false; });
        }
    }

    //Product Details Modal
    productDetailController.$inject = [
        "$mdDialog",
        "$q",
        "productApi",
        "arcProductApi",
        "arcBusinessApi",
        "arcLineOfBusinessCategoryApi",
        "arcLineOfBusinessApi",
        "productPlugins"
    ];
    function productDetailController(
        $mdDialog,
        $q,
        productApi,
        arcProductApi,
        arcBusinessApi,
        arcLineOfBusinessCategoryApi,
        arcLineOfBusinessApi,
        productPlugins
    ) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isClosing: false,
                    isSaving: false
                },
                plugins: productPlugins,
                toggleProductPlugin: toggleProductPlugin,
                close: close,
                save: save
            });

        $ctrl.$onInit = function () {
            //add product codes to plugins
            $ctrl.plugins.forEach(function (plugin) {
                if (plugin.ShortName.toLowerCase().includes('firelight'))
                    ng.extend(plugin, {
                        ProductCode: $ctrl.product.FirelightProductCode ? $ctrl.product.FirelightProductCode : 'N/A'
                    });
                if (plugin.ShortName.toLowerCase().includes('rightbridge'))
                    ng.extend(plugin, {
                        ProductCode: $ctrl.product.RightBridgeProductCode ? $ctrl.product.RightBridgeProductCode : 'N/A'
                    });
                if (plugin.ShortName.toLowerCase().includes('retireup'))
                    ng.extend(plugin, {
                        ProductCode: $ctrl.product.RetireUpProductCode ? $ctrl.product.RetireUpProductCode : 'N/A'
                    });
            });

            $ctrl.productJurisdiction = (function () {
                if ($ctrl.product.StateCodes.length > 0)
                    return $ctrl.product.StateCodes.map(function (state) { return state.trim(); }).sort().join(', ');

                return 'Available in all states';
            })();
        };

        function toggleProductPlugin(product, plugin) {
            var index = product.Plugins.indexOf(plugin.ShortName);

            if (index === -1) {
                product.Plugins.push(plugin.ShortName);
            } else {
                product.Plugins.splice(index, 1);
            }
        }

        function close() {
            $ctrl.UI.isClosing = true;
            return $mdDialog.hide({
                product: $ctrl.product
            });

        }

        function save(product) {
            $ctrl.UI.isSaving = true;

            var promises = [];

            if (!product.LineOfBusinessCategory.LineOfBusiness.Id) {
                promises.push(arcLineOfBusinessApi.create(product.LineOfBusinessCategory.LineOfBusiness.ArcLineOfBusinessId,
                    product.LineOfBusinessCategory.LineOfBusiness).then(function (response) {
                        product.LineOfBusinessCategory.LineOfBusiness.Id = response.Id;
                    }));
            }

            if (!product.Carrier.Business.Id) {
                promises.push(arcBusinessApi.create(product.Carrier.Business.ArcBusinessId, product.Carrier).then(function (response) {
                    product.Carrier.Business.Id = response.Business.Id;
                    product.Carrier.Id = response.Id;
                }));
            }

            return $q.all(promises).then(function () {
                if (!product.LineOfBusinessCategory.Id) {
                    return arcLineOfBusinessCategoryApi.create(product.LineOfBusinessCategory.ArcLineOfBusinessCategoryId, product.LineOfBusinessCategory)
                        .then(function (response) {
                            product.LineOfBusinessCategory.Id = response.Id;
                            saveProduct(product);
                            return $mdDialog.hide({
                                product: $ctrl.product
                            });
                        });
                } else {
                    saveProduct(product);
                    return $mdDialog.hide({
                        product: $ctrl.product
                    });
                }
            });
        }

        function saveProduct(product) {
            var promise;

            if (!product.Id) {
                promise = arcProductApi.create(product.ArcProductId, product).then(function (response) {
                    $ctrl.product = response;
                });
            } else {
                promise = productApi.updateProduct(product);
            }

            return promise.then(function () {
                $ctrl.UI.isSaving = false;
            });
        }

    }
})(window.app, window.angular); // jshint ignore:line